import Schema from "async-validator";
Schema.warning = function () {};
